import React from "react";

// Each "find yourself" page lives in its own bundle (it carries hundreds of
// photos' worth of data no other page needs). A plain React.lazy would render
// nothing on the first pass, which does not match the prerendered HTML, so
// React would throw away the page and redraw it (error #418). index.js
// therefore loads the bundle *before* hydrating when the visitor lands on one
// of these pages, and the route renders it directly once it is in memory.
const LOADERS = {
  "/gallery/bhaav-sangam-delhi": () => import("./GalleryArchive"),
  "/gallery/bhaav-sangam-chandigarh": () => import("./GalleryArchiveChandigarh"),
};

export const ARCHIVE_PATHS = Object.keys(LOADERS);

const loaded = {};
export const loadArchive = (path) =>
  LOADERS[path]().then((m) => {
    loaded[path] = m.default;
    return m;
  });
const lazies = Object.fromEntries(ARCHIVE_PATHS.map((p) => [p, React.lazy(() => loadArchive(p))]));

export default function ArchiveRoute({ path }) {
  const Loaded = loaded[path];
  if (Loaded) return <Loaded />;
  const Lazy = lazies[path];
  return (
    <React.Suspense fallback={null}>
      <Lazy />
    </React.Suspense>
  );
}
